import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { mergeMap, Observable, of } from 'rxjs';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from './auth.service';
import { AuthRepository } from './auth.repository';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private authRepository: AuthRepository
  ) {}

  authError(): Observable<boolean> {
    return this.authService.authError();
  }

  canActivate(
    _: ActivatedRouteSnapshot,
    __: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authRepository.userMe().pipe(
      mergeMap(({ user }) => {
        this.authService.setUser(user);
        return of(true);
      }),
      catchError(() => this.authError())
    );
  }
}
